'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { Networks, KBArticles, KBArticleSections } from 'AdsUI/lib/Constants';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import KnowledgeBaseLink from 'AdsUI/components/KnowledgeBaseLink';
const LEARN_MORE = {
  NO_REDIRECT: KBArticleSections[KBArticles.FIX_AD_TRACKING]['REDIRECT_AD_URLS'],
  FB_UNSUPPORTED_AD: KBArticleSections[KBArticles.FIX_AD_TRACKING]['INSUFFICIENT_PERMISSIONS'],
  FB_NO_PERMISSION: KBArticleSections[KBArticles.FIX_AD_TRACKING]['INSUFFICIENT_PERMISSIONS'],
  NO_PERMISSION: KBArticleSections[KBArticles.FIX_AD_TRACKING]['INSUFFICIENT_PERMISSIONS'],
  NO_PAGE_PERMISSION: KBArticleSections[KBArticles.FIX_AD_TRACKING]['INSUFFICIENT_PERMISSIONS'],
  GOOGLE_EDITED_TEMPLATE: KBArticleSections[KBArticles.FIX_AD_TRACKING]['OVERRIDING_CUSTOMIZED_TRACKING'],
  LI_SHARED_CONTENT_EDITED_TRACKING: KBArticleSections[KBArticles.FIX_AD_TRACKING]['LI_SHARED_CONTENT'],
  FB_TOO_MANY_ENGAGEMENTS: KBArticleSections[KBArticles.FIX_AD_TRACKING]['FB_TOO_MANY_ENGAGEMENTS'],
  FB_INVALID_IMAGE_CROP: KBArticleSections[KBArticles.FIX_AD_TRACKING]['FB_INVALID_IMAGE_CROP']
};
export const ExternalLink = props => /*#__PURE__*/_jsx(UILink, Object.assign({
  external: true
}, props));
export const LearnHowToFixLink = ({
  trackingErrorReason
}) => {
  if (!LEARN_MORE[trackingErrorReason]) {
    return null;
  }

  return /*#__PURE__*/_jsx(KnowledgeBaseLink, {
    kbArticle: KBArticles.FIX_AD_TRACKING,
    kbSection: LEARN_MORE[trackingErrorReason],
    context: "tracking-error-how-to-fix",
    onClick: () => usageTracker.track('trackingStatusSurveyAction', {
      action: 'Clicked learn how to fix',
      status: trackingErrorReason,
      isTrackingErrorsModal: true
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learnMore"
    })
  });
};
export const AdLink = ({
  children,
  entity,
  onClose
}) => {
  const {
    adNetwork,
    adGroupId,
    adAccountId,
    campaignId,
    id
  } = entity;

  switch (adNetwork) {
    case Networks.ADWORDS:
      return /*#__PURE__*/_jsx(Link, {
        to: `/accounts/adwords/${adAccountId}/campaigns/${id}`,
        onClick: onClose,
        children: children
      });

    default:
      return /*#__PURE__*/_jsx(Link, {
        to: `/accounts/${adNetwork.toLowerCase()}/${adAccountId}/campaigns/${campaignId}/adgroups/${adGroupId}`,
        onClick: onClose,
        children: children
      });
  }
};
export const FB_LEARNING_PHASE_URL = 'https://www.facebook.com/business/help/112167992830700?id=561906377587030';
export const FB_SETTINGS_URL = 'https://business.facebook.com/settings/ad-accounts/';
export const FB_PAGE_SETTINGS_URL = 'https://business.facebook.com/settings/pages';